module.exports = __webpack_public_path__ + "static/media/suitcase.515f33c6.svg";